import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import get from 'lodash/get';

import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Table from 'components/Table';
import Header from 'components/Table/Header';
import Cell from 'components/Cell';
import ExportButton from 'components/Export';
import Spinner from 'components/Spinner';
import { Tooltip } from 'antd';

const CompareTabContainer = styled.div`
  position: relative;
  display: grid;

  .columnTextOverflow {
    font-weight: 600;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding-left: 12px;
    padding-right: 12px;
  }

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .rightComponentsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    > div:not(:last-child) {
      margin-right: 10px;
    }
  }

  .width-table-overflow {
    width: calc(100vw - 180px);
    overflow-x: auto;

    @media (max-width: 845px) {
      width: calc(100vw - 72px);
    }
  }

  .hidden {
    display: none;
  }
`;

export default class CompareTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hoverExport: false,
      sorted: []
    };
  }

  handleSort(id) {
    let { sorted } = this.state;
    let desc = true;
    if (sorted.length > 0 && sorted[0].id === id) {
      desc = !sorted[0].desc;
    }
    sorted = [{ id, desc }];
    this.setState({ sorted });
  }

  atLeastOneWineHasNote(data, name) {
    let hasNote = false;
    data.forEach((set) => {
      if (set[name] && set[name] !== '-' && set[name] !== 0) {
        hasNote = true;
      }
    });
    return hasNote;
  }

  getColumns(isPrimeur) {
    const data = get(this.props, 'data', []);
    let columns = [
      {
        accessor: 'wine_name',
        Header: () => (
          <Header
            title={I18n.t('notes.compare.columns.wine')}
            sortable={true}
            sort={() => this.handleSort('wine_name')}
            styles={`justify-content:flex-start;padding-left:15px;padding-right:15px;`}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            className="columnTextOverflow"
            value={
              <Tooltip placement="bottomLeft" title={props.value}>
                {props.value}
              </Tooltip>
            }
          />
        ),
        width: 200
      },
      {
        accessor: isPrimeur ? 'wxr_primeur' : 'wxr_note',
        Header: () => (
          <Header
            title={I18n.t('notes.compare.columns.wxr')}
            sortable={true}
            sort={() => this.handleSort(isPrimeur ? 'wxr_primeur' : 'wxr_note')}
          />
        ),
        Cell: (props) => <Cell {...props}>{props.value}</Cell>,
        sortMethod: (a, b) => {
          return Number(a ? a : 0) - Number(b ? b : 0);
        }
      }
    ];
    if (data.length > 0) {
      data.forEach((currentWine) => {
        const columnsNames = columns.map((item) => item.name);
        Object.keys(currentWine).forEach((name) => {
          if (isPrimeur) {
            if (
              name.includes('_rawPrimeur') &&
              !name.includes('Float') &&
              name !== 'wxr_note' &&
              this.atLeastOneWineHasNote(data, name) &&
              !columnsNames.includes(name)
            ) {
              const order =
                currentWine[name.replace('_rawPrimeur', '_allnotes')] &&
                currentWine[name.replace('_rawPrimeur', '_allnotes')][0]
                  ? currentWine[name.replace('_rawPrimeur', '_allnotes')][0]
                      .order_display
                  : 1000;

              columns.push({
                accessor: name,
                name: name,
                order: order,
                Header: () => (
                  <Header
                    sortable={true}
                    sort={() => this.handleSort(name)}
                    tooltip={
                      currentWine[name.replace('_rawPrimeur', '_allnotes')] &&
                      currentWine[name.replace('_rawPrimeur', '_allnotes')]
                        .length > 0
                        ? {
                            placement: 'top',
                            content:
                              currentWine[
                                name.replace('_rawPrimeur', '_allnotes')
                              ][0].journalist_name
                          }
                        : undefined
                    }
                    title={name.replace('_rawPrimeur', '').toUpperCase()}
                    styles={`.title{font-size:12px}`}
                  />
                ),
                sortMethod: (a, b) => {
                  if (!a) {
                    a = '0';
                  }
                  if (!b) {
                    b = '0';
                  }
                  if (isNaN(Number(a))) {
                    if (a.includes('-')) {
                      a = a.split('-')[1];
                    }
                  }
                  if (isNaN(Number(b))) {
                    if (b.includes('-')) {
                      b = b.split('-')[1];
                    }
                  }

                  a = a.replace(',', '.');
                  b = b.replace(',', '.');

                  a = a.replace('+', '');
                  b = b.replace('+', '');
                  return Number(a) - Number(b);
                },
                Cell: (props) => <Cell {...props}>{props.value}</Cell>
              });
            }
          } else {
            if (
              name.includes('_rawNote') &&
              name !== 'wxr_note' &&
              this.atLeastOneWineHasNote(data, name) &&
              !columnsNames.includes(name)
            ) {
              const order =
                currentWine[name.replace('_rawPrimeur', '_allnotes')] &&
                currentWine[name.replace('_rawPrimeur', '_allnotes')][0]
                  ? currentWine[name.replace('_rawPrimeur', '_allnotes')][0]
                      .order_display
                  : 1000;

              columns.push({
                accessor: name,
                name: name,
                order: order,
                Header: () => (
                  <Header
                    sortable={true}
                    sort={() => this.handleSort(name)}
                    title={name.replace('_rawNote', '').toUpperCase()}
                    styles={`.title{font-size:12px}`}
                    tooltip={
                      data[0][name.replace('_rawNote', '_allnotes')] &&
                      data[0][name.replace('_rawNote', '_allnotes')].length > 0
                        ? {
                            placement: 'top',
                            content:
                              data[0][name.replace('_rawNote', '_allnotes')][0]
                                .journalist_name
                          }
                        : undefined
                    }
                  />
                ),
                Cell: (props) => <Cell {...props}>{props.value}</Cell>
              });
            }
          }
        });
      });
    }

    columns.sort(function (a, b) {
      return Number(a.order) - Number(b.order);
    });

    return columns;
  }

  render() {
    const {
      data,
      isPrimeur,
      wine,
      vintage,
      appelation,
      rank,
      type,
      exportName,
      loading
    } = this.props;
    const { sorted } = this.state;
    const columns = this.getColumns(isPrimeur);

    const classements =
      rank && rank.length > 0
        ? JSON.stringify(rank.map((value) => value.value))
        : '';
    const appelations =
      appelation && appelation.length > 0
        ? JSON.stringify(appelation.map((value) => value.value))
        : '';

    return (
      <CompareTabContainer>
        <Card>
          <CardHeader
            title={I18n.t('notes.compare.tableTitle')}
            fontSize="20px"
            iconRight
            rightComponents={
              <ExportButton
                name={exportName + I18n.t('notes.compare.tableTitle')}
                path="/communication/notation/compare/data/xls?"
                options={{
                  wine_name: wine,
                  vintage: vintage,
                  notation_type: type,
                  classements: classements,
                  appelations: appelations
                }}
                xls
                newApi
              />
            }
          />
          <div className="width-table-overflow">
            <Table
              data={data}
              columns={columns}
              sorted={sorted}
              subRowsKey={null}
            />
          </div>
        </Card>
        <Spinner loading={loading} little />
      </CompareTabContainer>
    );
  }
}
